"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useNoticeList = exports.postDeletePosts = exports.postUpdatePosts = exports.registPosts = exports.getNoticeList = void 0;
const classes_1 = require("../../features/base/classes");
const functions_1 = require("../functions");
const account_1 = require("../../features/base/account");
const getToken = () => (0, account_1.getAccessToken)(APP.store.getState);
const getNoticeList = async (queryString) => {
    const class_id = (0, classes_1.getClassesId)();
    const url = `/api/mimac/v1/posts?${queryString}&class_id=${class_id}`; // API 엔드포인트 생성
    return (0, functions_1.fetchData)(url);
};
exports.getNoticeList = getNoticeList;
// (게시글 등록) postsRegist
const registPosts = async (data) => {
    const url = `/api/mimac/v1/posts`;
    // console.log(getToken());
    return (0, functions_1.fetchData)(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${getToken()}`,
        },
        body: JSON.stringify(data),
    });
};
exports.registPosts = registPosts;
// (게시글 수정) postsModify
const postUpdatePosts = async (data) => {
    const url = `/api/mimac/v1/posts/${data.id}/update`;
    return (0, functions_1.fetchData)(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${getToken()}`,
        },
        body: JSON.stringify(data.props),
    });
};
exports.postUpdatePosts = postUpdatePosts;
// (게시글 삭제) postsModify
const postDeletePosts = async (id) => {
    const url = `/api/mimac/v1/posts/${id}/delete`;
    return (0, functions_1.fetchData)(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${getToken()}`,
        },
    });
};
exports.postDeletePosts = postDeletePosts;
const useNoticeList = (data) => {
    const queryString = (0, functions_1.objectToQueryString)(data); // props를 쿼리 문자열로 변환
    return (0, functions_1.useCustomQuery)([`notice`, data], () => (0, exports.getNoticeList)(queryString));
};
exports.useNoticeList = useNoticeList;
